import styled from 'styled-components';
import Button from 'components/Button/Button';
import type IButton from 'components/Button/shared/types/button';
import Icon from 'components/Icon/Icon';
import { verticalEllipsis } from 'modules/helpers/mixins';

type ChipProps = {
    onClick: () => void;
    showCloseIcon?: boolean;
    ellipsis?: boolean;
} & IButton;

const StyledButtonWithIcon = styled(Button)`
    width: fit-content;
    height: fit-content;
    text-align: left;
    display: flex;
    gap: ${({ theme }) => theme.Spacing8};
    `;

const EllipsisContainer = styled.div`
    ${verticalEllipsis(1)}
    line-height: 1.1; // Fixes issues where some letters gets cut off
`;

export default function Chip(props: ChipProps) {
    const { onClick, showCloseIcon, ellipsis, children, ...restProps } = props;

    return (
        <StyledButtonWithIcon
            variant="tertiary"
            size="sm"
            iconProperties={{
                position: 'right'
            }}
            onClick={onClick}
            {...restProps}
        >
            {ellipsis ? <EllipsisContainer>{children}</EllipsisContainer> : children}
            {showCloseIcon ? <Icon type="Close" size={16} /> : undefined}
        </StyledButtonWithIcon>
    );
}
